export default `
  mutation createOrgMember($orgId: String!, $email: String!, $role: OrgMemberRole) {
    createOrgMember(orgId: $orgId, email: $email, role: $role) {
      id
      orgId
      userId
      role
      email
      user {
        id
        firstname
        lastname
        email
      }
      createdAt
      updatedAt
    }
  }
`
